export default __webpack_public_path__ + "static/media/04_tag_indoor-pool.3d802a8f.svg";